<div class="container">
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
            <img src="assets/images/pagenotfound.jpg" class="img-fluid">
        </div>
        <div class="col-md-2"></div>
    </div>
</div>